/**
 * The modifier state a click carries. Structural rather than `MouseEvent` or
 * `React.MouseEvent` so both satisfy it — the callers are a React `onClick` and,
 * in tests, a native event.
 */
interface IClickModifiers {
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}

/**
 * True when a click is an unmodified primary-button click — the only kind a
 * link may intercept.
 *
 * Anything else is the user asking the browser for the `href`: a new tab, a new
 * window, a copied address. An anchor that calls `preventDefault()` on those
 * swallows the request and turns it into an in-place navigation, which on a
 * long-lived surface means a full document load — sockets closed, drafts gone.
 *
 * @param event - the click, or anything carrying its modifier state.
 */
export default function isPlainLeftClick(event: IClickModifiers): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}
